module.exports = __webpack_public_path__ + "img/user-group-me_en.2b20701b.png";